import React, { useState } from 'react'
import { Grid, Avatar, Button } from '@mui/material'
import { useFormikContext } from 'formik'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import { Cloudinary } from '@cloudinary/url-gen'

const TeacherAvatarUploader = () => {
  const [previewTeacherAvatarSource, setPreviewTeacherAvatarSource] =
    useState('')

  const { setFieldValue, values } = useFormikContext()

  const handleChangeAvatar = (e) => {
    if (e.target.files[0]) {
      const file = e.currentTarget.files[0]

      previewFile(file)

      setFieldValue('selectedTeacherAvatar', file)
    }
  }

  const previewFile = (file) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onloadend = () => {
      setPreviewTeacherAvatarSource(reader.result)
    }
  }

  const cld = new Cloudinary({
    cloud: {
      cloudName: 'youspeak',
    },
  })

  let cldTeacherAvatar = ''
  if (values && values.teacherAvatar) {
    const cldRes = cld.image(values.teacherAvatar)
    cldTeacherAvatar = cldRes.toURL()
  }

  return (
    <Grid item container direction="column" alignItems="center">
      <Grid item>
        <Avatar
          src={
            previewTeacherAvatarSource
              ? previewTeacherAvatarSource
              : cldTeacherAvatar
              ? cldTeacherAvatar
              : ''
          }
          style={{ width: '4em', height: '4em' }}
          alt="teacher-avatar"
        />
      </Grid>
      <Grid item>
        <p>
          Your avatar image <span style={{ color: 'red' }}>( * )</span>
        </p>
      </Grid>

      <Grid item container justifyContent="center" alignItems="center" spacing={1}>
        <Grid item>
          <Button
            variant="contained"
            component="label"
            color="primary"
            style={{ color: 'white', fontWeight: '500' }}
          >
            <AttachFileIcon />
            &nbsp;Select your avatar picture
            <input
              type="file"
              style={{ display: 'none' }}
              onChange={handleChangeAvatar}
            />
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default TeacherAvatarUploader
